import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Riddles from "./components/Riddles";
import Jokes from "./components/Jokes";
import Categories from "./components/admin/Categories";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/riddles" element={<Riddles />} />
        <Route path="/jokes" element={<Jokes />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/categories" element={<Categories />} />
      </Routes>
    </Router>
  );
}

export default App;
